module.exports = __webpack_public_path__ + "img/select.3b1499ce.svg";